import type { ErrorInfo } from "react";

export type ClientErrorContext = {
  boundary: string;
  error: Error;
  errorInfo?: ErrorInfo | null;
};

type WindowWithReporter = Window & {
  __REPORT_CLIENT_ERROR__?: (_payload: ClientErrorContext) => void;
};

function invokeExternalReporter(context: ClientErrorContext): void {
  if (typeof window === "undefined") return;
  const reporter = (window as WindowWithReporter).__REPORT_CLIENT_ERROR__;
  if (typeof reporter !== "function") return;
  try {
    reporter(context);
  } catch {
    /* monitoring hooks must never throw */
  }
}

export function reportClientError(context: ClientErrorContext): void {
  const { boundary, error, errorInfo } = context;
  invokeExternalReporter(context);
  const componentStack = errorInfo?.componentStack;
  if (process.env.NODE_ENV === "development") {
    console.error(`[${boundary}]`, error, componentStack ?? "");
    return;
  }
  console.error(`[${boundary}]`, {
    name: error.name,
    message: error.message,
    stack: error.stack,
    componentStack,
  });
}
